/**
 * useOnlineStatus — tracks navigator.onLine and the browser's
 * online/offline events. Returns { online, lastTransitionAt } so
 * components can show a reconnect toast on the offline → online edge.
 */

import { useEffect, useState } from 'react'

export interface OnlineStatus {
  online:             boolean
  lastTransitionAt:   number
}

export function useOnlineStatus(): OnlineStatus {
  const [state, setState] = useState<OnlineStatus>(() => ({
    online:           typeof navigator !== 'undefined' ? navigator.onLine : true,
    lastTransitionAt: Date.now(),
  }))

  useEffect(() => {
    const onUp = (): void => {
      setState((prev) => prev.online ? prev : { online: true,  lastTransitionAt: Date.now() })
    }
    const onDown = (): void => {
      setState((prev) => !prev.online ? prev : { online: false, lastTransitionAt: Date.now() })
    }
    window.addEventListener('online',  onUp)
    window.addEventListener('offline', onDown)
    return (): void => {
      window.removeEventListener('online',  onUp)
      window.removeEventListener('offline', onDown)
    }
  }, [])

  return state
}
